<template>
  <page
    :name="$t('Scadenza')"
    :title="title"
    :state="paymentState"
  >
    <template #header v-if="payment">
      <p>{{ $t('In scadenza al {0}', [$date(payment.data)]) }}</p>
    </template>

    <pf-page-section >
      <payment-report
        v-if="payment"
        :result="Number($route.query.res)"
        :error="$pop($route.query.err)"
        :success="$t('Saldo scadenza confermato')"
        route="invoices"
        :link="$t('Torna alla lista delle fatture')"
      >
        <x-form
          v-if="payment.amount > 0"
          action="/api/pay_invoice"
          :prevent-submit="!method"
          @before-submit="beforeSubmit"
          :submit-text="$t('Procedi al pagamento')"
          :submit-help="$t('Verrai reindirizzato alla pagina di pagamento. L\'operazione può durare qualche secondo.')"
          style="max-width: 800px;"
        >
          <input type="hidden" name="payment_id" :value="payment.id">

          <payment-methods
            v-model="method"
            :totale-offerta-ivato="payment.amount"
            :currency="login.currency"
            invoice
          />

          <form-group :name="$t('Totale')">
            {{ $currency(payment.amount, login.currency) }} <span class="vat">({{$t('IVA inclusa')}})</span>
          </form-group>
        </x-form>
      </payment-report>

      <pf-alert v-else variant="danger" :title="$t('Errore: Pagamento non trovato')" />
    </pf-page-section>
  </page>
</template>

<style scoped>
.form-group.methods label {
  margin-right: 15px;
}
</style>

<script lang="ts" setup>
import { ref, type Ref, computed } from 'vue';
import PaymentReport from '../components/payment-report.vue';
import PaymentMethods, { type Method} from '../components/payment-methods.vue';
import { asyncComputed } from '@common/asyncComputed';
import { useLoginStore } from '@/store/login';
import { usePaypalStore } from '@/store/paypal';
import { PaymentsResource } from '@/resources';
import { pop } from '@common/utils';
import { useRoute } from 'vue-router';

const route = useRoute();
const login = useLoginStore();

const { state: paymentState, result: payment } = asyncComputed(async() => {
  const id = pop(route.params.id);
  if (login.id_azienda && id) {
    return await new PaymentsResource().get(id);
  }
  return null;
});

const method: Ref<Method | undefined> = ref();

function beforeSubmit() {
  if (method.value === 'axerve-paypal') {
    const paypal = usePaypalStore();
    paypal.save();
  }
  return true;
};

const title = computed(() => {
  return `${payment.value?.fattura ? `${payment.value?.tipo} nr. ${payment.value.fattura}: ` : ''}${payment.value?.descrizione}`;
});
</script>
